import { render, staticRenderFns } from "./ServicesView.vue?vue&type=template&id=b1668c78&scoped=true"
import script from "./ServicesView.vue?vue&type=script&lang=js"
export * from "./ServicesView.vue?vue&type=script&lang=js"
import style0 from "./ServicesView.vue?vue&type=style&index=0&id=b1668c78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1668c78",
  null
  
)

export default component.exports